<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" :width="1000">
    <table class="QHtable" v-if="show">
      <tr>
        <td style="width: 125px"><b>车牌号码</b></td>
        <td>{{ row.licensePlate }}</td>
      </tr>
      <tr>
        <td><b>车辆名称</b></td>
        <td>{{ row.name }}</td>
      </tr>
      <tr>
        <td><b>车辆载量</b></td>
        <td>{{ row.carVolume }}m³</td>
      </tr>

      <tr>
        <td><b>车辆类型</b></td>
        <td>
          <span v-if="row.carKind == 100">新能源自卸车</span>
          <span v-if="row.carKind == 600">新能源重型自卸车</span>
          <span v-if="row.carKind == 200">新能源勾臂车</span>
          <span v-if="row.carKind == 300">四驱燃油自卸车</span>
          <span v-if="row.carKind == 400">三轮燃油自卸车</span>
          <span v-if="row.carKind == 500">其他</span>
        </td>
      </tr>
      <tr>
        <td><b>运输单位</b></td>
        <td>{{ row.orgName }}</td>
      </tr>
      <tr>
        <th>资质证件</th>
        <th>
          <QHButton A="A222" size="default" style="float: right" @Tap="$refs.setQualification.hiCreated(row.id, 500)" v-if="isAuth"> 资质上传</QHButton>
        </th>
      </tr>
      <tr v-if="!row.information500">
        <td colspan="10">暂无证件资质信息</td>
      </tr>
      <tr v-for="(item, index) in row.information500" :key="index">
        <td>
          <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
        </td>
        <td>
          <div class="flex-between">
            <div>
              <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
              <span class="MR5 CL5" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
              <span>{{ item.name }}</span>
              <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
            </div>
            <div class="flex-between" style="margin-left: 10px">
              <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </Modal>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "车辆详情",
      show: false,
      isAuth: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:唤起修改
    // +----------------------------------------------------------------------
    hiPop(e, isAuth) {
      this.isAuth = isAuth;
      this.$loading(true);
      this.$api.getCarDetailed({ id: e.id }).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    // +----------------------------------------------------------------------
    // | Desc:开始清运
    // +----------------------------------------------------------------------
    deleteData(id) {
      //请求入库
      var that = this;
      var confirm = {
        title: "删除资质",
        msg: "<p>一旦删除就不可撤销，只能重新上传！</p>",
      };
      this.$confirm(confirm, function () {
        //参数整合与接口
        var https = {
          isLoading: "isLoadingPop",
          api: that.$api.removeCarQualification,
          parameter: {
            id: id,
          },
          successMsg: "删除成功",
        };
        that.$httpsApi(
          https,
          function (res) {
            that.hiPop(that.row, that.isAuth);
            that.$emit("success");
          },
          function (res) {
            that.$alert(res.msg);
          }
        );
      });
    },
  },
};
</script>
